export default __webpack_public_path__ + "static/media/person-2.f0bc2a07.png";